export const DEFAULT_MAX_DAYS = 2
export const NUMBER_OF_DIGITS = 2

export const hInD = 24
export const mInH = 60
export const sInM = 60
export const msInS = 1000
